import React from 'react';
import dekan from '../Images/Dekan.png'

const Baxtiyor = () => {
    return (
        <div style={{color: 'black'}}>
            <div className='container text-start'>
                <div className='row'>
                    <div className='col-10'>
                        <h1 className='text-center'>МАЪЛУМОТНОМА</h1>
                        <h2 className='text-center'>Шарипов Бахтиёр Михлибаевич</h2>
                        <p>2021 йил 6 сентябрдан:</p>
                        <p>Чилонзор туман 2-сон касб-ҳунар мактабининг - Ўқув - методик бўлими бошлиғи</p>
                    </div>   
                    <div className='col-2'>
                        <img src={dekan} />
                    </div>    
                </div> 
                <div className='row'>
                    <div className='col'>
                        <p className='h5'>Туғилган йили:</p>
                        <p>02.12.1968</p>
                        <p className='h5'>Миллати:</p>
                        <p>ўзбек</p>
                        <p className='h5'>Маълумоти:</p>
                        <p>олий</p>
                        <p className='h5'>Маълумоти бўйича мутахассислиги:</p>
                        <p className='h5'>Илмий даражаси:</p>
                        <p>йўқ</p>
                        <p className='h5'>Қайси чет тилларини билади:</p>
                        <p>рус тили, француз тили</p>
                        <p className='h5'>Давлат мукофотлари билан тақдирланганми (қанақа):</p>
                        <p>йўқ</p>
                        <p className='h5'>Халқ депутатлари, республика, вилоят, шаҳар ва туман Кенгаши депутатими ёки бошқа
сайланадиган органларнинг аъзосими (тўлиқ кўрсатилиши лозим)	</p>
                        <p>йўқ</p>
                    </div>
                    <div className='col'>
                    <p className='h5'>Туғилган жойи:</p>
                        <p>Навоий вилояти, Навбахор тумани</p>
                        <p className='h5'>Партиявийлиги:</p>
                        <p>йўқ</p>
                        <p className='h5'>Тамомлаган:</p>
                        <p>1991 й. Тошкент халқ хўжалиги институти (кундузги)</p>
                        <p>меҳнат иқтисодчи</p>
                        <p className='h5'>Илмий унвони:</p>
                        <p>йўқ</p>
                        <p className='h5'>Ҳарбий (махсус) унвони:</p>
                        <p>йўқ</p>
                    </div>
                </div>
                <p className='h3'>МЕҲНАТ ФАОЛИЯТИ</p>
                <p>1991-1994 йй. - Тошкент халқ хўжалиги институти "Меҳнат иқтисодиёти ва социологияси" кафедрасига ассисент</p>
                <p>1994-2003 йй. - "Меҳнат иқтисодиёти ва социологияси" кафедраси кундузги аспиранти ассисенти</p>
                <p>2003-2004 йй. - Г В Плеханова номидаги Россия иқтисодиёт академияси Тошкент филиали ўқитувчиси</p>
                <p>2004-2010 йй. - "Меҳнат иқтисодиёти ва социологияси" кафедраси кундузги ассисенти катта ўқитувчиси</p>
                <p>2010-2010 йй. - Г В Плеханова номидаги Россия иқтисодиёт академияси Тошкент филиали ўқитувчиси</p>
                <p>2015-2016 йй. - Тошкент давлат техника университети қошидаги 5-сонли академик лицейининг ўитувчи</p>
                <p>2016-2016 йй. - Тошкент хизмат кўрсатиш ва сервис касб-ҳунар коллежининг махсус фан ўқитувчиси</p>
                <p>2016-2020 йй. - Тошкент банк ҳисоб-кредит коллежининг - ўқтувчиси</p>
                <p>2020-2021 йй. - Чилонзор туман 2-сон касб-ҳунар мактабининг - "Махсус фан" ўқитувчиси</p>
                <p>2021 й. -  ҳ.в.  - Чилонзор туман 2-сон касб-ҳунар мактабининг - Ўқув - методик бўлими бошлиғи</p>
                    <br />
                <p className='h2'>Малумотнома паспорт, диплом ва меҳнат дафтарчасига асосан тўғри ёзилган</p>
                <div className='row'>
                    <div className='col'>
                        <p className='h4'>КҲМ директори:</p>
                        <p className='h4'>Кадрлар бўйича инспектори:</p>
                    </div>
                    <div className='col'>
                        <p className='h4'>  Б.И.Тўйинов</p>
                        <p className='h4'>  Ш.А.Райимқулов  </p>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default Baxtiyor;